export var ACCOUNT_MENU_EVENT_NAME = 'account_menu';